/**
 * Get content session from brightspot
 *
 */
import { gql } from '@apollo/client'

export const vendorsGQLQuery = () => {
  return gql(`{
    RootsTechSearchPage(id: "/dosearch", types: ["e3b470da-fdf3-3f89-9eca-f29e304cacd1"]) {
         results {
          url
          title
          contentUUID
        }
      }
    }
  `)
}

export const dummy = () => {}
